import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiMessageSquare, FiAlertCircle, FiArrowRight } = FiIcons;

export default function CourseFacilitatorGuide({ modules, selectedId, onSelect }) {
  const module = modules.find((item) => item.id === selectedId) || modules[0];

  return (
    <div className="grid gap-6 lg:grid-cols-[260px_minmax(0,1fr)]">
      <nav className="space-y-2" aria-label="Velg kursledermodul">
        {modules.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => onSelect(item.id)}
            className={`w-full rounded-xl border p-3 text-left text-sm ${
              module.id === item.id ? 'border-blue-400 bg-blue-50 text-blue-900' : 'border-slate-200 bg-white text-slate-700'
            }`}
          >
            <span className="font-semibold">{item.id}. {item.title}</span>
            <span className="mt-1 block text-xs text-slate-500">{item.duration} minutter</span>
          </button>
        ))}
      </nav>

      <article className="space-y-5 rounded-2xl border border-slate-200 bg-white p-6">
        <header>
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-blue-700">
            <SafeIcon icon={FiClock} /> {module.duration} minutter
          </p>
          <h2 className="mt-2 text-2xl font-bold text-slate-900">{module.title}</h2>
          <p className="mt-2 text-sm leading-6 text-slate-600">Læringsmål: {module.objective}</p>
        </header>
        <section className="rounded-xl bg-blue-50 p-4">
          <h3 className="font-bold text-blue-900">Hovedbudskap</h3>
          <p className="mt-1 text-sm leading-6 text-blue-900">{module.keyMessage}</p>
          <p className="mt-2 text-sm leading-6 text-blue-900">{module.explanation}</p>
        </section>
        <section>
          <h3 className="mb-2 inline-flex items-center gap-2 font-bold text-slate-900"><SafeIcon icon={FiMessageSquare} /> Spørsmål til deltakerne</h3>
          <ul className="list-disc space-y-1 pl-5 text-sm text-slate-600">
            {module.questions.map((question) => <li key={question}>{question}</li>)}
          </ul>
        </section>
        <section className="grid gap-4 md:grid-cols-2">
          <div className="rounded-xl border border-slate-200 p-4">
            <h3 className="font-bold text-slate-900">Eksempel og aktivitet</h3>
            <p className="mt-2 text-sm leading-6 text-slate-600">{module.example}</p>
            <p className="mt-2 text-sm leading-6 text-slate-600">{module.facilitatorActivity}</p>
          </div>
          <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
            <h3 className="inline-flex items-center gap-2 font-bold text-amber-900"><SafeIcon icon={FiAlertCircle} /> Pass på</h3>
            <p className="mt-2 text-sm leading-6 text-amber-900">{module.watchFor}</p>
          </div>
        </section>
        <p className="flex items-center gap-2 border-t border-slate-100 pt-4 text-sm font-semibold text-slate-700">
          <SafeIcon icon={FiArrowRight} /> Overgang: {module.transition}
        </p>
      </article>
    </div>
  );
}